<template>
  <template v-if="store.loaded">
    <div :class="['top', {'mobile-top': store.showMobile}]">
      <h4>Россия, Хабаровск</h4>
      <p></p>
      <a v-if="store.phone" :href="'tel:' + store.phone.replaceAll(' ', '')"><h2>{{ store.phone }}</h2></a>
      <a href="mailto:peppers-studio@mail.ru" target="_blank">
        <h2>peppers-studio@mail.ru</h2>
      </a>
    </div>
    <div :class="['about', {'mobile-about': store.showMobile}]">
      <h4>Кто мы?</h4>
      <p>Мы — люди, которые делают РЕКЛАМУ. Ту, что показывают по ТВ, ту, что звучит по радио, ту, что можно увидеть в Интернете или на рекламном щите.</p>
      <p></p>
      <h4>Чем мы отличаемся от других?</h4>
      <p>Мы делаем фильмы, ролики, аудио, 3D-графику, анимацию и т.д., но мы отчетливо понимаем, что… реклама — это прежде всего идея, поэтому… Мы можем придумать ИДЕЮ или развить вашу, но мы откажемся делать рекламу без идеи, ведь и вам этого не надо.</p>
      <p></p>
      <h4>Почему наша реклама работает?</h4>
      <p>Потому что перед тем как взяться за заказ, мы стараемся УЗНАТЬ все о том, что предстоит рекламировать, ПОНЯТЬ цели и предпочтения людей, ИЗУЧИТЬ рынок и его тенденции, не стесняемся СПРОСИТЬ мнения узких специалистов, и ПОИНТЕРЕСОВАТЬСЯ у соседки — тети Гали, каким стиральным порошком она пользуется, и почему. Мы считаем, что хорошая рекламная идея — это не только ВДОХНОВЕНИЕ, но и ЗНАНИЯ и ОПЫТ. Поэтому мы ВСЕГДА ПРОДОЛЖАЕМ УЧИТЬСЯ и получать информацию.</p>
      <p></p>
      <h4>Зачем мы вам?</h4>
      <p>Как вы ремонтируете автомобиль — залезаете в мотор по пояс сами или едете в автосервис? Если ваш выбор — последнее, то мы — лучший автосервис на рекламном рынке города. В другом случае мы увидимся чуть позже, и починка рекламного мотора вашего бизнеса обойдется вам чуть дороже.</p>
      <p></p>
      <h4>Зачем вы нам?</h4>
      <p>А мы разве не сказали? ПРОСТО МЫ ЛЮБИМ СВОЮ РАБОТУ — а вам она нужна!</p>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMainStore } from '@/store';

export default defineComponent({
  name: "AboutView",
  data () {
    return {
      store: useMainStore()
    }
  }
})
</script>

<style scoped>

.top {
  padding: 5rem 5rem 5rem 5rem;
}

.about {
  pointer-events: all;
  /* height: calc(100vh - 10rem); */
  width: calc(100% - 5rem);
  font-size: .8rem;
  padding: 0rem 1rem 0 5rem;
  overflow-y: auto;
}

.about p {
  padding-top: 1rem;
  white-space: break-spaces;
}

/* ================ */
/* Мобильная версия */
/* ================ */

.mobile-top {
  display: grid;
  gap: 1rem;
  padding: 7rem 2rem 2rem 2rem;
}

.mobile-about {
  width: 100%;
  font-size: 1rem;
  padding: 0 2rem 2rem 2rem;
  overflow-y: unset;
}

</style>
